import {
  CHECK,
  CHECK_FAILURE,
  CHECK_SUCCESS,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_SUCCESS,
  GOOGLE_INITIALIZED,
  LOGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_FAILURE,
  LOGOUT_SUCCESS,
  REGISTER_SAGA,
  RESET_PASSWORD,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_SUCCESS,
  SENT_RESET_PASSWORD,
  SENT_RESET_PASSWORD_FAILURE,
  SENT_RESET_PASSWORD_PENDING,
  SENT_RESET_PASSWORD_SUCCESS,
  GET_USERDATA,
  GET_USERDATA_SUCCESS,
  GET_USERDATA_FAILURE,
  GET_SUBLIST,
  GET_SUBLIST_SUCCESS,
  GET_SUBLIST_FAILURE,
  UPDATE_USER,
  UPDATE_USER_FAILURE,
  UPDATE_USER_SUCCESS,
  SET_PASSWORD,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILURE,
  TOGGLE_MENU,
  UPDATE_ALL_FEED_ACCESS,
  CHECK_EMAIL_SUB,
  CHECK_EMAIL_SUB_SUCCESS,
  CHECK_EMAIL_SUB_FAILURE,
  UPDATE_EMAIL_SUB,
  UPDATE_EMAIL_SUB_SUCCESS,
  UPDATE_EMAIL_SUB_FAILURE,
  GET_APP_QR,
  GET_APP_QR_SUCCESS,
  GET_APP_QR_FAILURE,
  GET_MENU_INDICATORS,
  GET_MENU_INDICATORS_SUCCESS,
  GET_MENU_INDICATORS_FAILURE,
  TOKEN_REFRESHED,
} from "./constants";
const actions = {
  registerSaga: () => {
    return {
      type: REGISTER_SAGA,
    };
  },
  login: (credentials, history) => {
    return {
      type: LOGIN,
      credentials,
      history,
    };
  },
  loginSuccess: (payload) => {
    return {
      type: LOGIN_SUCCESS,
      payload,
    };
  },
  loginFailure: (error) => {
    return {
      type: LOGIN_FAILURE,
      error,
    };
  },
  check: (token, history) => {
    return {
      type: CHECK,
      token,
      history,
    };
  },

  checkSuccess: (payload) => {
    return {
      type: CHECK_SUCCESS,
      payload,
    };
  },
  checkFailure: (error) => {
    return {
      type: CHECK_FAILURE,
      error,
    };
  },
  updateUser: (token, history, onUpdateSuccess, payload) => {
    return {
      type: UPDATE_USER,
      token,
      history,
      onUpdateSuccess,
      payload,
    };
  },

  updateUserSuccess: (payload) => {
    return {
      type: UPDATE_USER_SUCCESS,
      payload,
    };
  },
  updateUserFailure: (error) => {
    return {
      type: UPDATE_USER_FAILURE,
      error,
    };
  },
  logout: (history) => {
    return {
      type: LOGOUT,
      history,
    };
  },
  logoutSuccess: (payload) => {
    return {
      type: LOGOUT_SUCCESS,
      payload,
    };
  },
  logoutFailure: (error) => {
    return {
      type: LOGOUT_FAILURE,
      error,
    };
  },
  setGoogleReference: (payload) => {
    return {
      type: GOOGLE_INITIALIZED,
      payload,
    };
  },
  sentResetLink: (payload) => {
    return {
      type: SENT_RESET_PASSWORD,
      payload,
    };
  },
  sentResetLinkPending: (payload) => {
    return {
      type: SENT_RESET_PASSWORD_PENDING,
      payload,
    };
  },
  sentResetLinkSuccess: (payload) => {
    return {
      type: SENT_RESET_PASSWORD_SUCCESS,
      payload,
    };
  },
  sentResetLinkFailure: (payload) => {
    return {
      type: SENT_RESET_PASSWORD_FAILURE,
      payload,
    };
  },

  forgotPassword: (credentials, onSuccess) => {
    return {
      type: FORGOT_PASSWORD,
      credentials,
      onSuccess,
    };
  },
  forgotPasswordSuccess: (payload) => {
    return {
      type: FORGOT_PASSWORD_SUCCESS,
      payload,
    };
  },
  forgotPasswordFailure: (error) => {
    return {
      type: FORGOT_PASSWORD_FAILURE,
      error,
    };
  },
  resetPassword: (credentials, history) => {
    return {
      type: RESET_PASSWORD,
      credentials,
      history,
    };
  },
  resetPasswordSuccess: (payload, onResetSuccess) => {
    return {
      type: RESET_PASSWORD_SUCCESS,
      payload,
      onResetSuccess,
    };
  },
  resetPasswordFailure: (error) => {
    return {
      type: RESET_PASSWORD_FAILURE,
      error,
    };
  },
  getUserData: (payload) => {
    return {
      type: GET_USERDATA,
      payload,
    };
  },
  getUserDataSuccess: (payload) => {
    return {
      type: GET_USERDATA_SUCCESS,
      payload,
    };
  },
  getUserDataFailure: (error) => {
    return {
      type: GET_USERDATA_FAILURE,
      error,
    };
  },
  getSubList: (payload) => {
    return {
      type: GET_SUBLIST,
      payload,
    };
  },
  getSubListSuccess: (payload) => {
    return {
      type: GET_SUBLIST_SUCCESS,
      payload,
    };
  },
  getSubListFailure: (error) => {
    return {
      type: GET_SUBLIST_FAILURE,
      error,
    };
  },
  setPassword: (credentials, history) => {
    return {
      type: SET_PASSWORD,
      credentials,
      history,
    };
  },
  setPasswordSuccess: (payload, onSetSuccess) => {
    return {
      type: SET_PASSWORD_SUCCESS,
      payload,
      onSetSuccess,
    };
  },
  setPasswordFailure: (error) => {
    return {
      type: SET_PASSWORD_FAILURE,
      error,
    };
  },
  toggleMenu: (payload) => {
    return {
      type: TOGGLE_MENU,
      payload,
    };
  },
  updateAllFeedAccess: (payload) => {
    return {
      type: UPDATE_ALL_FEED_ACCESS,
      payload,
    };
  },
  checkEmailSub: (payload, callback) => {
    return {
      type: CHECK_EMAIL_SUB,
      payload,
      callback,
    };
  },
  checkEmailSubSuccess: (payload) => {
    return {
      type: CHECK_EMAIL_SUB_SUCCESS,
      payload,
    };
  },
  checkEmailSubFailure: (error) => {
    return {
      type: CHECK_EMAIL_SUB_FAILURE,
      error,
    };
  },
  updateEmailSub: (payload, callback) => {
    return {
      type: UPDATE_EMAIL_SUB,
      payload,
      callback,
    };
  },
  updateEmailSubSuccess: (payload) => {
    return {
      type: UPDATE_EMAIL_SUB_SUCCESS,
      payload,
    };
  },
  updateEmailSubFailure: (error) => {
    return {
      type: UPDATE_EMAIL_SUB_FAILURE,
      error,
    };
  },
  getAppQR: (payload) => {
    return {
      type: GET_APP_QR,
      payload,
    };
  },
  getAppQRSuccess: (payload) => {
    return {
      type: GET_APP_QR_SUCCESS,
      payload,
    };
  },
  getAppQRFailure: (error) => {
    return {
      type: GET_APP_QR_FAILURE,
      error,
    };
  },
  getMenuIndicators: (payload) => {
    return {
      type: GET_MENU_INDICATORS,
      payload,
    };
  },
  getMenuIndicatorsSuccess: (payload) => {
    return {
      type: GET_MENU_INDICATORS_SUCCESS,
      payload,
    };
  },
  getMenuIndicatorsFailure: (error) => {
    return {
      type: GET_MENU_INDICATORS_FAILURE,
      error,
    };
  },
  tokenRefreshed: (token) => {
    return {
      type: TOKEN_REFRESHED,
      payload: token,
    };
  },
};
export default actions;
